import { Tag } from 'antd';
import { STATUS_COLORS, STATUS_LABELS } from '../utils/constants';
import type { OrderStatus } from '../types';

interface StatusBadgeProps {
  status: OrderStatus;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  return (
    <Tag color={STATUS_COLORS[status]}>
      {STATUS_LABELS[status]}
    </Tag>
  );
};
